module.exports = __webpack_public_path__ + "static/media/alumio-horizontal-white.8afc192a.svg";